import * as React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Table from "@mui/material/Table";
import { useSelector } from "react-redux";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import { GetSystems, getGenerator } from "../../../services/systems.handlers";
import { Link } from "react-router-dom";
import AddGenerator from "./AddGenerator";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import { _getCountryName, getCountryName } from "../../../constants";

const TableRowData = [
  " Ser. No.",
  "Attached to System",
  "Part No",
  "Rev",
  "HW_Rev",
  "SW_Rev",
  "Build Date",
  "Build Location",
  "Router",
  "Status",
  "Action",
];

const Generator = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [IsAssociated, setIsAssociated] = React.useState(false);
  const [systemId, setSystemId] = React.useState("");
  const authToken = useSelector((state) => state.user.authToken);
  React.useEffect(() => {
    fetchData();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = () => {
    var options = {
      Authorization: "Bearer " + authToken,
    };
    getGenerator(options).then((response) => {
      if (response.status) {
        setData(response.data);
        setIsAssociated(
          response.data.some(
            (element) => element.isAssociated_WithSystem === true
          )
        );
      }
    });
  };

  return (
    <DashboardLayout>
      <h3 style={{ marginBottom: -5, marginTop: 0 }}>Generator</h3>
      <hr></hr>
      {/* <Stack
        spacing={40}
        direction="row"
        style={{
          // marginTop: "16px",
          marginBottom: "30px",
          justifyContent: "space-between",
        }}
      >
        <h3 style={{ marginBottom: -5, marginTop: 0, marginLeft: 12 }}>
          Generator
        </h3>
        <Button
          style={{ marginRight: 86, height: 45 }}
          onClick={() => navigate("/addGenerator")}
          variant="contained"
        >
          <AddIcon /> Add Generator
        </Button>
      </Stack> */}
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size={"medium"}
        >
          <TableHead>
            <TableRow>
              {TableRowData.map((item, index) => (
                <TableCell key={index}>
                  {index == -1 ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          inputProps={{
                            "aria-label": "select all ID",
                          }}
                        />
                      }
                      label={item}
                    />
                  ) : (
                    item
                  )}
                </TableCell>
              ))}
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 && IsAssociated ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(
                  (item, index) =>
                    item.isAssociated_WithSystem === true && (
                      <TableRow hover key={index}>
                        <TableCell>
                          {/* <Link to={"/generator-detail-page/" + item.id}> */}
                          <Link
                            to="/generator-detail-page"
                            state={{ id: item.id, storeId: item.storeId }}
                          >
                            {item.gen_Id}
                          </Link>
                          {/* <br></br>
                        {item.system_Sn !== "" && (
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Attched to System - {item.system_Sn}
                          </div>
                        )} */}
                        </TableCell>
                        <TableCell style={{ width: "111px" }}>
                          {/* <Link to={"/systems-detail-page/" + item.systemId}> */}
                          <Link
                            to="/systems-detail-page"
                            state={{ id: item.systemId, storeId: item.storeId }}
                          >
                            {item.system_Sn}
                          </Link>
                        </TableCell>

                        <TableCell style={{ width: "150px" }}>
                          <>
                            {item.component_No}-
                            {item.country_Code
                              ? item.country_Code.substring(0, 3)
                              : ""}
                            -{item.variant}-{item.gen_Id}
                            <br></br>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "102px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              {/* {getCountryName(item?.country_Code)} */}
                              {item.country_Code
                                ? item.country_Code.substring(4)
                                : ""}
                            </div>
                          </>
                        </TableCell>
                        <TableCell>{item.genRev_No}</TableCell>
                        <TableCell>{item.hw}</TableCell>
                        <TableCell>{item.sW_Rev}</TableCell>
                        <TableCell>
                          {moment(item.genBuild_Date).format("YYYY/MM/DD")}
                        </TableCell>
                        <TableCell style={{ width: "155px" }}>
                          {item.genBuild_Location}
                        </TableCell>
                        <TableCell style={{ width: "155px" }}>
                          {item.genRouter}
                        </TableCell>
                        <TableCell>
                          {item.isActive ? (
                            <span className={"label color-green"}>Active</span>
                          ) : (
                            <span className={"label color-red"}>Blocked</span>
                          )}
                        </TableCell>
                        <TableCell>
                          <Button
                            disabled={item.isAssociated_WithSystem}
                            onClick={() =>
                              navigate("/updateGenerator/" + item.id)
                            }
                            variant="contained"
                            color="primary"
                          >
                            Edit
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                )
            ) : (
              <TableRow hover>
                <TableCell colSpan={11} align={"center"}>
                  No Records Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 30, 40]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </DashboardLayout>
  );
};

export default Generator;
